export function initHomeSlider($) {
	if(document.home_slides) {
		let slides = document.home_slides;
		// pick a random slide
		const random = Math.floor(Math.random() * slides.length);

		populateSlide($, slides[random]);
	}
}

function populateSlide($, slide) {
	$('#home-heading').html(slide.heading);
	$('#home-subheading').html(slide.subheading);
	$('#home-paragraph').html(slide.paragraph);
	$("#home-header").addClass(slide.header_position);
	$('#home-header').css("background-image", "url(" + slide.image + ")");
}

export function initSlider($) {

	// slider for microsite homepage
	$('.slider:not(.slider-block)').each(function(n, el) {
		$('.owl-carousel', el).owlCarousel({
			items: 1,
			loop: true,
			nav: false,
			dots: true,
			autoplay: true,
			autoplayTimeout: 10000,
			navText: [
                '<i class="slider-fa-control fal fa-chevron-left"></i>',
                '<i class="slider-fa-control fal fa-chevron-right"></i>'
            ],
			navElement: 'div',
			animateIn: 'fadeIn',
			animateOut: 'fadeOut',
			onInitialized: (event) => addDotNavText(event, $),
			onResized: (event) => addDotNavText(event, $),
		});
	});

	// slider block
	$('.slider.slider-block').each(function(n, el) {
		$('.owl-carousel', el).owlCarousel({
			items: 1,
			loop: true,
			nav: false,
			dots: true,
			autoplay: true,
			autoplayTimeout: 7000,
			smartSpeed: 7000,

			animateIn: 'fadeIn',
			animateOut: 'fadeOut',

			onInitialized: (event) => addDotNavText(event, $),
			onResized: (event) => addDotNavText(event, $),
		});
	});

	$('.slider2.slider2preview').each(function(n, el) {
		$('.owl-carousel', el).owlCarousel({
			items: 1,
			loop: true,
			nav: true,
			dots: false,
			autoplay: false,
			autoplayTimeout: 7000,
			navText: [
				'<i class="fal fa-circle-arrow-left"></i>',
				'<i class="fal fa-circle-arrow-right"></i>'
			],
			navElement: 'div',
			responsive:{
				0:{
					stagePadding:0
				},
				1200:{
					stagePadding: 100,
					margin: 30
				}
			},

			onInitialized: (event) => addDotNavText(event, $),
			onResized: (event) => addDotNavText(event, $),
		});
	});

	$('.slider2.slider2normal').each(function(n, el) {
		$('.owl-carousel', el).owlCarousel({
			items: 1,
			loop: true,
			nav: true,
			dots: false,
			autoplay: true,
			autoplayTimeout: 7000,
			navText: [
				'<i class="fal fa-circle-arrow-left"></i>',
				'<i class="fal fa-circle-arrow-right"></i>'
			],
			navElement: 'div',

			onInitialized: (event) => addDotNavText(event, $),
			onResized: (event) => addDotNavText(event, $),
		});
	});

	$('.info-column-carousel .owl-carousel').each(function(n, el) {
		$(el).owlCarousel({
			items: 4,
			slideBy: 4,
			dotsEach: 4,
			loop: true,
			nav: true,
			dots: false,
			// autoplay: true,
			// autoplayTimeout: 10000,
			margin: 70,
			navText: [
				'<i class="fal fa-arrow-left"></i>',
				'<i class="fal fa-arrow-right"></i>'
			],
			navElement: 'div',

			responsive:{
				0:{
					items: 1,
					slideBy: 1,
					dotsEach: 1,
					margin: 0,
				},
				768:{
					items: 3,
					slideBy: 3,
					dotsEach: 3,
					margin: 30,
				},
				1024:{
					items: 4,
					slideBy: 4,
					dotsEach: 4,
					margin: 70,
				}
			},

			onInitialized: (event) => addDotNavText(event, $),
			onResized: (event) => addDotNavText(event, $),
		});
	});


	$('.statistics-carousel .owl-carousel').each(function(n, el) {
		$(el).owlCarousel({
			items: 3,
			slideBy: 3,
			dotsEach: 3,
			loop: true,
			nav: true,
			dots: false,
			// autoplay: true,
			// autoplayTimeout: 10000,
			margin: 70,
			navText: [
				'<i class="fal fa-arrow-left"></i>',
				'<i class="fal fa-arrow-right"></i>'
			],
			navElement: 'div',

			responsive:{
				0:{
					items: 1,
					slideBy: 1,
					dotsEach: 1,
					margin: 0,
				},
				768:{
					items: 3,
					slideBy: 3,
					dotsEach: 3,
					margin: 30,
				},
				1024:{
					items: 3,
					slideBy: 3,
					dotsEach: 3,
					margin: 70,
				}
			},

			onInitialized: (event) => addDotNavText(event, $),
			onResized: (event) => addDotNavText(event, $),
		});
	});
}


function addDotNavText(event, $) {
	$('.owl-dot', event.target).each(function(n, el) {
		$(el).attr('aria-label', 'Go to slide ' + (n + 1));
	});
}